






import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'CatalogBarWrapper',
  props: {
    safeArea: Boolean as PropType<boolean>,
  },
  computed: {
    isEmpty(): boolean {
      return !this.$slots.default;
    },
  },
});
